import { Component, ViewChild, ElementRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../auth/services';
import { UserService } from '../../../dashboard/services';

@Component({
  selector: 'kt-app-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private authService = inject(AuthService);
  private userService = inject(UserService);
  
  readonly currentUser = this.userService.currentUser;
  readonly isAuthenticated = this.authService.isLoggedIn;

  @ViewChild('myNav') navbarMenu!: ElementRef;

  toggleNavbar(): void {
    const navbarCollapse = document.querySelector('#navbarSupportedContent');
    if (navbarCollapse) {
      navbarCollapse.classList.remove('show');
    }
  }

  logoutUser(){
    this.userService.clearCurrentUser();
    this.authService.logout();
  }
}
